import React from 'react'

interface Warning {
  children: React.ReactNode
}

const Warning: React.FC<Warning> = ({ children }) => {
  return (
    <div className="flex items-center justify-center gap-x-[6px] p-4 rounded-md border border-yellow-300 dark:border-yellow-800 bg-yellow-50 dark:bg-yellow-600/20">
      {children}
    </div>
  )
}

export default Warning
